module.exports = __webpack_public_path__ + "img/fi-Funded by the EU_NEG.fec4568.svg";